export default __webpack_public_path__ + "static/media/grafema_ciceco_05.c9f1cba0.jpg";